import Vue from 'vue'
import axios from 'axios'
// import $store from '../store'

// axios.defaults.headers.post['X-CSRF-Token'] = $store.state.general.user.csrf
axios.defaults.xsrfHeaderName = 'xsrf_default_overwritten'

Vue.prototype.$axios = axios
